import { CoObjectAdvancedTablePanel } from "../table/CoObjectAdvancedTablePanel";
import { SourceTypeEnum } from "../../../api/models/source-type-enum";
import { CoObjectAdvancedAmountPanel } from "../amount/CoObjectAdvancedAmountPanel";
import React from "react";
import { ObjectPanelTabs } from "./ObjectPanelComponent";
import { DocumentPartMetadata } from "../../../api/models/document-part-metadata";

interface AdvancedPanelContainerProps {
  documentPartMetadata: DocumentPartMetadata;
  isEdit: boolean;
  isLocked: boolean;
  isComponentInstance: boolean;
  objectType: string;
  objectSource: any;
  updateObjectAdvanced: (obj, tabValid, modified) => void;
  objectAdvanced: any;
  tab: ObjectPanelTabs;
  isFileExcelExisting?: boolean;
}

export const AdvancedPanelContainer = (props: AdvancedPanelContainerProps) => {
  const {
    documentPartMetadata,
    isEdit,
    isLocked,
    isComponentInstance,
    objectType,
    objectSource,
    objectAdvanced,
    updateObjectAdvanced,
    tab,
    isFileExcelExisting,
  } = props;

  if (!isEdit || objectAdvanced) {
    switch (objectType) {
      case "CHART":
      case "TABLE":
        return (
          <CoObjectAdvancedTablePanel
            documentPartMetadata={documentPartMetadata}
            objectAdvanced={objectAdvanced}
            tab={tab}
            updateCoObjectAdvancedTable={(obj, tabValid, modified) => updateObjectAdvanced(obj, tabValid, modified)}
            isEdit={isEdit}
            isComponentInstance={isComponentInstance}
            isFileExcelExisting={isFileExcelExisting}
            isLocked={isLocked}
          />
        );
      case "AMOUNT":
      case "AMOUNT_AIH":
        if (objectSource !== SourceTypeEnum.EXCEL && objectSource !== SourceTypeEnum.TAGETIK_FORM) {
          return (
            <CoObjectAdvancedAmountPanel
              tab={tab}
              isEdit={isEdit}
              isComponentInstance={isComponentInstance}
              updateCoObjectAdvancedAmount={(obj, tabValid, modified) => updateObjectAdvanced(obj, tabValid, modified)}
              objectAdvanced={objectAdvanced}
              documentPartMetadata={documentPartMetadata}
              isLocked={isLocked}
            />
          );
        } else {
          return (
            <CoObjectAdvancedTablePanel
              documentPartMetadata={documentPartMetadata}
              objectAdvanced={objectAdvanced}
              tab={tab}
              updateCoObjectAdvancedTable={(obj, tabValid, modified) => updateObjectAdvanced(obj, tabValid, modified)}
              isEdit={isEdit}
              isFileExcelExisting={isFileExcelExisting}
              isComponentInstance={isComponentInstance}
              isLocked={isLocked}
            />
          );
        }
    }
  }
  return null;
};
